import { BaseTodoPlannerModel } from './base-todo-planner.model';

export class MonthTodoPlannerModel extends BaseTodoPlannerModel {}
